import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import { LockClosedIcon, UserGroupIcon } from '@heroicons/react/20/solid';
import { useAuth } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

const ICON_CLASSES =
  'group-hover:text-rcprimary-400 h-5 w-5 flex-none text-white/60';

function NavigationDesktopDropdownMenu({
  navElements,
  title,
  icon,
  showSignOut = false,
}) {
  const { currentUser, signOut } = useAuth();

  return (
    <Menu as="div" className="relative shrink-0">
      <div>
        <MenuButton className="flex max-w-xs items-center rounded-xl text-black text-sm hover:text-rcprimary-400 focus:outline-hidden">
          <span className="sr-only">{title}</span>
          {currentUser.imageUrl !== null &&
          currentUser.imageUrl !== undefined &&
          currentUser.imageUrl !== '' ? (
            <img
              className="inline-block size-8 rounded-full"
              src={currentUser.imageUrl}
              alt="Profile"
            />
          ) : (
            icon
          )}
        </MenuButton>
      </div>
      <Transition
        as="div"
        className="absolute right-0 z-[999] mt-1 w-56 origin-top-right py-1 text-white shadow-lg ring-1 ring-black/5 transition duration-100 ease-out focus:outline-hidden data-closed:scale-95 data-enter:scale-100 data-leave:scale-95 data-closed:opacity-0 data-enter:opacity-100 data-leave:opacity-0"
      >
        <MenuItems className="absolute right-0 z-[999] mt-0 w-56 origin-top-right rounded-md border border-rcprimary-100/30 bg-black/90 py-1 text-white shadow-lg ring-1 ring-black/5 focus:outline-hidden">
          {navElements.map((item) => (
            <MenuItem key={item.name} className="hover:text-rcprimary-400">
              {item.isExternal ? (
                <a
                  href={item.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="data-active-text-rcprimary-400 group flex w-full items-center justify-start gap-x-2.5 px-4 py-2 text-left text-sm text-white"
                >
                  {item.icon && (
                    <item.icon className={ICON_CLASSES} aria-hidden="true" />
                  )}
                  {item.name}
                </a>
              ) : (
                <NavLink
                  to={item.to}
                  className="data-active-text-rcprimary-400 group flex w-full items-center justify-start gap-x-2.5 px-4 py-2 text-left text-sm text-white"
                >
                  {item.icon && (
                    <item.icon className={ICON_CLASSES} aria-hidden="true" />
                  )}
                  {item.name}
                </NavLink>
              )}
            </MenuItem>
          ))}

          {currentUser.roleLevel !== 0 && (
            <MenuItem className="hover:text-rcprimary-400">
              <NavLink
                to="/admins/users"
                className="data-active-text-rcprimary-400 group flex w-full items-center justify-start gap-x-2.5 px-4 py-2 text-left text-sm text-white"
              >
                <UserGroupIcon className={ICON_CLASSES} aria-hidden="true" />
                Admin Users
              </NavLink>
            </MenuItem>
          )}

          {showSignOut && (
            <MenuItem className="hover:text-rcprimary-400">
              <button
                type="button"
                onClick={signOut}
                className="data-active-text-rcprimary-400 group flex w-full items-center justify-start gap-x-2.5 px-4 py-2 text-left text-sm text-white"
              >
                <LockClosedIcon className={ICON_CLASSES} aria-hidden="true" />
                Sign Out
              </button>
            </MenuItem>
          )}
        </MenuItems>
      </Transition>
    </Menu>
  );
}

NavigationDesktopDropdownMenu.propTypes = {
  navElements: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  showSignOut: PropTypes.bool,
};

export default NavigationDesktopDropdownMenu;
